/** @format */

import { useCallback, useEffect, useState } from "react";
import { Brand, ImportJob } from "@question-bank/shared";
import { getImport } from "../api/imports";

interface UseImportJobReturn {
	job: ImportJob | null;
	isLoading: boolean;
	error: string | null;
	reload: () => void;
}

/**
 * Loads a single CSV import job by id
 */

export const useImportJob = (brand: Brand, jobId: string): UseImportJobReturn => {
	const [job, setJob] = useState<ImportJob | null>(null);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);
	const [reloadToken, setReloadToken] = useState(0);

	const reload = useCallback(() => setReloadToken((token) => token + 1), []);

	useEffect(() => {
		let isCancelled = false;
		setIsLoading(true);
		setError(null);
		setJob(null);

		getImport(brand, jobId)
			.then((result) => {
				if (!isCancelled) {
					setJob(result);
				}
			})
			.catch((err) => {
				if (!isCancelled) {
					setError(err instanceof Error ? err.message : "failed to load import job");
				}
			})
			.finally(() => {
				if (!isCancelled) {
					setIsLoading(false);
				}
			});

		return () => {
			isCancelled = true;
		};
	}, [brand, jobId, reloadToken]);
	return { job, isLoading, error, reload };
};
